import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useQuery() {
    const [sp] = useSearchParams();

    return useMemo(() => ({
        clientId: sp.get('clientId') ?? '',
        type:     sp.get('type')     ?? '',  // 'emis' | 'recu' | ''
        year:     sp.get('year')     ?? '',
        month:    sp.get('month')    ?? '',
    }), [sp]);
}
